import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import MapPicker from '../Shared/MapPicker.vue';
export default {
    name: 'Students',
    mixins: [HelperMixin],
    components: {
        PaginationHelper,
        MapPicker
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Students list — Admin (1), School owner (40), School admin (41).
        if (!this.requireUserType([1, 40, 41])) return;

        // لو مستخدم مدرسة نفلتر على مدرسته
        if (this.loginDetails.userType == 40 || this.loginDetails.userType == 41) {
            this.selectedSchool = this.getSchoolId();
        }

        this.GetInfo(this.pageNo);
        this.GetAllSchools();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            selectedSchool: '',
            selectedStatus: '',

            ScreenTitle: 'الطلاب',
            ScreenTitleSingle: 'طالب',
            ScreenTitleSingleAl: 'الطالب',

            Info: [],
            Statistics: [],
            Schools: [],

            SelectedItem: '',

            ruleForm: {
                Id: null, UsersId: null, SchoolsId: '',
                FirstName: '', FatherName: '', SirName: '', Name: '',
                Phone: '', Descriptions: '',
                Address: '', Latitude: null, Longitude: null,
                RegistrationNumber: '', AcademicYear: ''
            },
            mapValue: { lat: null, lng: null },

            suspendForm: {
                StudentId: '',
                Reason: ''
            },
        };
    },

    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetStudents(this.pageNo, this.pageSize, this.Search, this.selectedSchool, this.selectedStatus)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetAllSchools() {
            this.$http.GetAllSchools()
                .then(response => {
                    this.Schools = response.data.info;
                })
                .catch(() => {
                    this.Schools = [];
                });
        },

        submitForm() {
            const form = document.getElementById('studentForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(0);

            const n = this.normalizePhone(this.ruleForm.Phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح (مثال: 0911234567).');
                return;
            }
            this.ruleForm.Phone = n;

            // Optional id fields are bound as long? on the server; an empty
            // string ('') fails model binding with a 400. Send null instead.
            if (this.ruleForm.SchoolsId === '') this.ruleForm.SchoolsId = null;
            if (this.ruleForm.UsersId === '') this.ruleForm.UsersId = null;

            this.$blockUI.Start();
            this.$http.AddStudents(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UsersId = item.userId;
            this.ruleForm.SchoolsId = item.schoolsId;
            this.ruleForm.FirstName = item.firstName;
            this.ruleForm.FatherName = item.fatherName;
            this.ruleForm.SirName = item.sirName;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Descriptions = item.descriptions;
            this.ruleForm.Address = item.address || '';
            this.ruleForm.Latitude = item.latitude != null ? item.latitude : null;
            this.ruleForm.Longitude = item.longitude != null ? item.longitude : null;
            this.ruleForm.RegistrationNumber = item.registrationNumber || '';
            this.ruleForm.AcademicYear = item.academicYear || '';
            this.mapValue = { lat: item.latitude, lng: item.longitude };
            this.state = 1;
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UsersId = item.userId;
            this.ruleForm.SchoolsId = item.schoolsId;
            this.ruleForm.FirstName = item.firstName;
            this.ruleForm.FatherName = item.fatherName;
            this.ruleForm.SirName = item.sirName;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Descriptions = item.descriptions;
            this.ruleForm.Address = item.address || '';
            this.ruleForm.Latitude = item.latitude != null ? item.latitude : null;
            this.ruleForm.Longitude = item.longitude != null ? item.longitude : null;
            this.ruleForm.RegistrationNumber = item.registrationNumber || '';
            this.ruleForm.AcademicYear = item.academicYear || '';
            this.mapValue = { lat: item.latitude, lng: item.longitude };
        },

        submitEditForm() {
            const form = document.getElementById('studentForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(this.ruleForm.Id);

            const n = this.normalizePhone(this.ruleForm.Phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح (مثال: 0911234567).');
                return;
            }
            this.ruleForm.Phone = n;

            this.$blockUI.Start();
            this.$http.EditStudents(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هـل انت متأكد من عملية تغير حالة الطالب؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusStudents(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدث خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هـل انت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteStudents(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        SelectImage(file) {
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type;
            str = str.substring(0, 5);

            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },

        OpenSuspendModal(item) {
            this.SelectedItem = item;
            this.suspendForm = {
                StudentId: item.id,
                Reason: ''
            };
        },

        submitSuspend() {
            const form = document.getElementById('suspendForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال سبب التعليق');
                return;
            }

            form.classList.remove('was-validated');

            if (!this.suspendForm.Reason || this.suspendForm.Reason.trim() === '') {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال سبب التعليق');
                return;
            }

            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: "سيتم تعليق حساب هذا الطالب",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'نعم، قم بالتعليق',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.SuspendStudent(this.suspendForm)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.$helper.DestroyElemntById('CloseSuspendModal');
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        CancelSuspend(Id) {
            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: "سيتم إلغاء تعليق حساب هذا الطالب",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'نعم، قم بإلغاء التعليق',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelSuspend(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        Back() {
            this.SelectedItem = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

    }
}
